import { Typography } from '@mui/material';

import { CLONE_DIALOG_ACTIVE_SX, CLONE_DIALOG_INACTIVE_SX, CLONE_DIALOG_TEXT_SX } from '../styles';

import type { ClonePlanDialogContentProps } from './types';

export default function ClonePlanDialogContent({
  isPlanActive,
  planLabel,
  clientLabel,
}: ClonePlanDialogContentProps) {
  if (isPlanActive) {
    return (
      <Typography sx={CLONE_DIALOG_TEXT_SX}>
        Are you sure you want to clone the current{' '}
        <Typography component="span" sx={CLONE_DIALOG_ACTIVE_SX}>
          active
        </Typography>{' '}
        treatment plan {planLabel} for client {clientLabel}?
      </Typography>
    );
  }

  return (
    <Typography sx={CLONE_DIALOG_TEXT_SX}>
      You&apos;re about to clone treatment plan {planLabel} for client {clientLabel}, but this plan
      is{' '}
      <Typography component="span" sx={CLONE_DIALOG_INACTIVE_SX}>
        not active.
      </Typography>
    </Typography>
  );
}
